// SPDX-License-Identifier: AGPL-3.0-or-later

export const VOICE_DEBUG_SPEAKER_SAMPLE_INTERVAL_MS = 30000;

// Speaking changes can consume the entire local event history in minutes. Keep
// occasional samples there; the staff-enabled upload queue still receives every
// event. Connection, participant and track events are never sampled.
export class VoiceDebugEventSampler {
	private lastSpeakerSampleAt: number | null = null;

	shouldRetain(type: string, nowMs: number): boolean {
		if (type !== 'livekit.active_speakers.changed') return true;
		if (
			this.lastSpeakerSampleAt !== null &&
			nowMs >= this.lastSpeakerSampleAt &&
			nowMs - this.lastSpeakerSampleAt < VOICE_DEBUG_SPEAKER_SAMPLE_INTERVAL_MS
		) {
			return false;
		}
		this.lastSpeakerSampleAt = nowMs;
		return true;
	}
}
